import { ApolloError, useQuery } from '@apollo/client';

import { Role } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { IsAccountHolderDocument } from './isAccountHolder.gql';

interface IsAccountHolderResult {
  isAccountHolder?: boolean;
  loading: boolean;
  error?: ApolloError;
}

const useIsAccountHolder = (): IsAccountHolderResult => {
  const { companyProfileId } = useCompanyContext();

  const { data, error, loading } = useQuery(IsAccountHolderDocument, {
    skip: !companyProfileId,
    variables: { companyProfileId: companyProfileId as string },
  });

  return {
    error,
    isAccountHolder:
      data?.viewer.companyUser.roles.includes(Role.AccountHolder) ?? undefined,
    loading,
  };
};

export default useIsAccountHolder;
